<template>
  <VModal name="template-remove-modal" :loading="loading">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('template.removeTemplate') }}</h2>
    </template>
    <template v-slot:content>
      <i18n path="template.removeTemplateWarning" tag="p">
        <template v-slot:company>
          <span class="font-bold">{{ $t('template.removeTemplateWarningCompanyName', {name: company.name}) }}</span>
        </template>
      </i18n>
      <VForm :onSubmit="validateForm" data-vv-scope="reminders-cancel" ref="form">
        <div slot="row" v-if="errorMessage">
          <VMessage type="error" subtype="basic">
            <template v-slot:icon>
              <LifeRingIcon />
            </template>
            <template v-slot:text>
              {{ errorMessage }}
            </template>
          </VMessage>
        </div>
        <div slot="formButtons">
          <VButton
              type="error"
              subtype="submit"
              class="float-right"
              href="#"
              data-ec="templates_remove_template_modal"
              data-et="remove_template_button">
            <TrashIcon />
            <span>{{ $t('template.removeTemplate') }}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import { LifeRingIcon, TrashIcon } from '@/components/icons/fontIcons';
import { mapGetters } from 'vuex';

export default {
  name: 'TemplateRemoveModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    template: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VButton,
    VMessage,
    VForm,
    VModal,
    TrashIcon,
    LifeRingIcon,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters({
      company: 'company/company',
    }),
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          this.$store.dispatch('template/DELETE', this.template).then((res) => {
            if (!res.error) this.$bus.$emit('closeModal');
            this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.success.removed', { name: 'template' }), icon: 'check', type: 'success' }));
            this.$router.push({ name: 'Templates', params: { pageNumber: 1 } });
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
